/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import { is } from 'ramda'
import React from 'react'

import { SmallText } from './Text'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Icon from '../../components/shapes/Icon'
import Link from '../actions/Link'

export const Tags = ({ values, children, onRemove, ...props }) => (
  <FlexGrid justify="flex-start" gutter={0.2} wrap flex={1} {...props}>
    {values.map((value, index) => (
      <Tag
        key={`${value}-${index}`}
        label={value}
        onRemove={onRemove ? () => onRemove(index, value) : undefined}
        {...props}
      />
    ))}
    <FlexCol flex={1}>{children}</FlexCol>
  </FlexGrid>
)

const Tag = ({ bgColor, color, transparent, medium, small, fixedSize, label, circle, onRemove, ...props }) => {
  color = color || bgColor || COLORS.dark3
  color = color || COLORS.purple
  if (!label) return false

  let sidePadding = 0.7
  let minWidth = 0
  let minHeight = medium ? 1.8 : 1
  if (fixedSize) {
    sidePadding = 0.1

    minWidth = medium ? 1.8 : 1
  }
  if (small) {
    minHeight = 0.3
    sidePadding = 0.3
  }

  const isText = is(String, label) || is(Number, label)

  const style = css`
    background-color: ${color};
    ${transparent
      ? `
			background-color: ${COLORS.transparent};
			border: solid 1px ${color};
		`
      : ''}
    padding: 0.1rem ${sidePadding}rem;
    border-radius: ${circle ? '5rem' : '5px'};
    display: flex;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: ${minWidth}rem;
    min-height: ${minHeight}rem;
    margin-right: 5px;
  `

  return (
    <div css={style}>
      {isText ? (
        <FlexGrid gutter={0.2} direction="row">
          <SmallText
            size={small ? 'xxsmall' : 'xsmall'}
            color={transparent ? color : COLORS.white}
            weight="600"
            noWrap
            {...props}
          >
            {label}
          </SmallText>
          {onRemove && (
            <Link onClick={onRemove}>
              <Icon name="BsX" onClick={onRemove} size=".75rem" color={COLORS.white} />
            </Link>
          )}
        </FlexGrid>
      ) : (
        label
      )}
    </div>
  )
}

export default Tag
